module.exports = __webpack_public_path__ + "static/media/brand-b9660fd0fd0ba793b8b8beb38dcbad18b847981943d0061345615378312a8bc9.c7eab404.svg";